<script lang="ts" setup>
import { formatDate } from "@/common/helpers"
/**
 *
 *  Props and emits section
 *
 *
 */

const props = defineProps<{
    post: Post
}>()

const emits = defineEmits<{
    (event: "show", post: Post): void
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const computedLink = computed(() => {
    return `/blog/${props.post.slug}`
})

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */

const getImageSource = (image: any) => {
    if (image && "id" in image) {
        return image.type === "image/avif" ? image.origin : image.thumb
    } else {
        return ""
    }
}

const getImageId = (image: any) => {
    if (image && "id" in image) {
        return image.id
    } else {
        return ""
    }
}

const getImageStyle = (image: string) => {
    const imageObject = new Image()
    imageObject.src = image

    return {
        backgroundSize: "contain",
        backgroundPosition: "center center",
    }
}
</script>
<template>
    <div class="tw-flex tw-flex-col tw-w-full tw-h-full card-container">
        <div
            class="tw-bg-white tw-cursor-pointer tw-rounded-md tw-relative tw-border tw-flex tw-flex-col tw-gap-4 tw-justify-between tw-pb-5 tw-h-full"
        >
            <div
                class="tw-flex tw-justify-center tw-w-full tw-relative tw-p-[17px]"
            >
                <div class="tw-rounded-sm tw-flex-nowrap tw-h-[270px]">
                    <NuxtImg
                        v-if="post.main_images"
                        :style="getImageStyle(post.main_images.origin)"
                        :src="post.main_images.origin || '/img/placeholder.png'"
                        class="tw-w-full tw-h-full tw-rounded-md card_image tw-object-contain"
                    />
                    <NuxtImg
                        v-else
                        :src="'/img/placeholder.png'"
                        class="tw-w-full tw-h-full tw-rounded-md card_image tw-object-contain"
                    />
                </div>
            </div>

            <div
                class="tw-px-4 tw-relative tw-flex tw-flex-col tw-gap-4 tw-justify-between tw-h-full"
            >
                <p class="tw-text-customGray-300 tw-text-xs tw-self-start"></p>

                <div class="tw-flex tw-flex-col tw-gap-3 tw-h-full">
                    <p
                        class="tw-text-xl tw-text-gray-700 tw-font-[500] tw-text-start tw-my-0"
                    >
                        {{ post.title }}
                    </p>
                    <div class="tw-flex tw-gap-2 tw-text-sm tw-items-center">
                        <div class="tw-flex tw-gap-2 tw-items-center">
                            <q-icon name="event" color="primary" />
                            <span class="tw-sm-text tw-font-extralight">{{
                                formatDate(post.public_at)
                            }}</span>
                        </div>
                        <div class="tw-ml-2 tw-flex tw-gap-2 tw-items-center">
                            <IconSell />
                            <span class="tw-sm-text tw-font-extralight">{{
                                post.author
                            }}</span>
                        </div>
                    </div>

                    <p
                        class="tw-line-clamp-6 tw-overflow-hidden tw-text-md tw-font-light tw-leading-normal tw-text-ellipsis tw-break-words"
                    >
                        {{ post.summary }}
                    </p>
                </div>

                <NuxtLink
                    :href="computedLink"
                    class="tw-text-primary tw-text-bold tw-italic"
                    >{{ $t("actions.read_more") }}</NuxtLink
                >
            </div>
        </div>
    </div>
</template>
<style>
.card_image {
    @apply tw-bg-no-repeat tw-aspect-product-card-image tw-relative;
}

.card-container:hover .button_card_product {
    @apply !tw-inline hover:tw-text-primary;
    transition: all 0.2s ease;
}

.card-container:hover .card_image {
    transform: scale(1.1);
    transition: all 0.5s ease;
    transform-origin: center center;
}
</style>
